import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type KEY_FEATURE_FLAGS = 'claimFreeWLD' | 'banner' | 'iframe' | 'siweAuth';

const data: Record<KEY_FEATURE_FLAGS, { dev: boolean; prod: boolean }> = {
    claimFreeWLD: {
        dev: true,
        prod: true,
    },
    banner: {
        dev: true,
        prod: true,
    },
    iframe: {
        dev: true,
        prod: false,
    },
    siweAuth: {
        dev: true,
        prod: true,
    },
};
const getDataDefaut = () => {
    const temp: Record<KEY_FEATURE_FLAGS, boolean> = {
        claimFreeWLD: false,
        banner: false,
        iframe: false,
        siweAuth: false,
    };
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const element = data[key as keyof typeof data];
            if (import.meta.env.MODE == 'production') {
                temp[key as keyof typeof data] = element.prod;
            } else {
                temp[key as keyof typeof data] = element.dev;
            }
        }
    }

    return temp;
};

interface IConfigs {
    featureFlags: Record<string, boolean>;
}

export const configStore = create<IConfigs>()(() => ({
    featureFlags: getDataDefaut(),
}));

export function useFeatureFlags() {
    const featureFlags: Record<KEY_FEATURE_FLAGS, boolean> = configStore(
        useShallow((state) => state.featureFlags)
    );

    return featureFlags;
}
